// TODO: Add types for 'unknown' responses and 'any' parameters
import { createAsyncThunk } from '@reduxjs/toolkit';
import { API } from '../../network/api';
import { UsersResponse } from 'types/response';
import { AxiosResponse } from 'axios';

export const getGroupStatusData = createAsyncThunk<unknown, any>(
  'dashboard/groupsstatus',
  async (params, thunkAPI) => {
    try {
      const url = `/dashboard/v2`;
      const queryParams = { offset: 1, paged: true, ...params };
      const response = await API.get(url, { params: queryParams });
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getOperationsSnaphot = createAsyncThunk<unknown, any>(
  'dashboard/getOperationsSnaphot',
  async ({ country, seasonIndex, dashboardApiVersion = 'v1' }, thunkAPI) => {
    const url =
      dashboardApiVersion === 'v1'
        ? `/dashboard/getActiveFarmerInformation`
        : `/dashboard/${dashboardApiVersion}/getActiveFarmerInformation`;

    try {
      const params = {
        ...(country && { country: country }),
        ...(seasonIndex && { seasonType: seasonIndex }),
      };
      const response = await API.get(url, { params });
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getAgronomist = createAsyncThunk<UsersResponse, string>(
  'dashboard/getAgronomist',
  async (country, thunkAPI) => {
    try {
      const url = `/user/search/`;
      const params = {
        'role.in': 'Agronomist,Jr Agronomist,Jr. Agronomist,Jr Agronomist (External)',
        ...(country && { 'country.equals': country }),
        sort: 'name,asc',
        page: 0,
        size: 9999, // This is done as an interim fix to get all the agronomist at once, will be replaced with an infinite scroll strategy later
      };
      const response: AxiosResponse<UsersResponse> = await API.get(url, { params });
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getSrAgronomist = createAsyncThunk<UsersResponse>(
  'dashboard/getSrAgronomist',
  async (_, thunkAPI) => {
    try {
      const url = `/user?role.in=Sr.%20Agronomist,%20Sr%20Agronomist&size=100&page=0`;
      const response: AxiosResponse<UsersResponse> = await API.get(url);
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getSeasonIndexData = createAsyncThunk<unknown[], any>(
  'season/seasonIndex',
  async (country, thunkAPI) => {
    try {
      const url = `/season/country/seasonIndex`;
      const params = {
        ...(country && { "country.equals": country }),
      };
      const response = await API.get(url, { params });
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getSubDistrictData = createAsyncThunk(
  'dashboard/getSubDistrictData',
  async (country, thunkAPI) => {
    try {
      const url = `/dashboard/subdistrict/`;
      const params = {
        country,
      };
      const response = await API.get(url, { params });
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
